import * as tslib_1 from "tslib";
import { Selector } from '@swim/recon';
import { ModelParam } from '@swim/ui';
import { MapboxGeometryModel } from './mapbox-geometry-model';
var MapboxPointModel = (function (_super) {
    tslib_1.__extends(MapboxPointModel, _super);
    function MapboxPointModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MapboxPointModel.Params = MapboxGeometryModel.Params.concat([
        new ModelParam('coordinates', Selector.get('coordinates')),
        new ModelParam('properties', Selector.get('properties')),
    ]);
    return MapboxPointModel;
}(MapboxGeometryModel));
export { MapboxPointModel };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWFwYm94LXBvaW50LW1vZGVsLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibWFwYm94LXBvaW50LW1vZGVsLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQSxPQUFPLEVBQUMsUUFBUSxFQUFDLE1BQU0sYUFBYSxDQUFDO0FBQ3JDLE9BQU8sRUFBQyxVQUFVLEVBQUMsTUFBTSxVQUFVLENBQUM7QUFDcEMsT0FBTyxFQUFDLG1CQUFtQixFQUFDLE1BQU0seUJBQXlCLENBQUM7QUFFNUQ7SUFBc0MsNENBQW1CO0lBQXpEOztJQUtBLENBQUM7SUFKaUIsdUJBQU0sR0FBRyxtQkFBbUIsQ0FBQyxNQUFNLENBQUMsTUFBTSxDQUFDO1FBQ3pELElBQUksVUFBVSxDQUFDLGFBQWEsRUFBRSxRQUFRLENBQUMsR0FBRyxDQUFDLGFBQWEsQ0FBQyxDQUFDO1FBQzFELElBQUksVUFBVSxDQUFDLFlBQVksRUFBRSxRQUFRLENBQUMsR0FBRyxDQUFDLFlBQVksQ0FBQyxDQUFDO0tBQ3pELENBQUMsQ0FBQztJQUNMLHVCQUFDO0NBQUEsQUFMRCxDQUFzQyxtQkFBbUIsR0FLeEQ7U0FMWSxnQkFBZ0IifQ==